import i18n from "../../i18n";

export const ADDRESS_SOURCE = [
  { value: "past_addresses", label: i18n.t("newOrder.AddressSource.PastAddresses") },
  { value: "new_address", label: i18n.t("newOrder.AddressSource.NewAddress") },
  { value: "pickup", label: i18n.t("newOrder.AddressSource.Pickup") },
];
